import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Pipe, PipeTransform, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxExtendedPdfViewerService, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DxButtonModule, DxFormModule, DxLoadPanelModule, DxScrollViewModule, DxTabPanelModule, DxTabsModule, DxToolbarModule } from 'devextreme-angular';
import { Observable, Subject, takeUntil } from 'rxjs';
import { PdfViewService } from './pdf-view.service';
import { DkDxDataCtlTableComponent, DkFormPopupComponent, FormFooterComponent, FormHeaderComponent } from '../components';
import {DlistDto, FormDto} from '../../models/ortak.dtos';
import { ColumnModel } from '../../models/dx-data-table.model';
import { OrtakService } from '../../services/ortak.service';
import { TaslakBelgeGirisiUstBilgiComponent } from 'libs/bys/src/lib/components/taslak-girisi/taslak-girisi-edit/taslak-girisi-edit-ust-bilgi/taslak-belge-girisi-ust-bilgi.component';
import { WordViewerComponent } from '../../../../../../bys/src/lib/components/ortak/dk-word-viewer/dk-word-viewer.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FocusedRowChangedEvent, RowPreparedEvent } from 'devextreme/ui/data_grid';
import { DkGlobalUserSettingsService } from '../../services/dk-global-user-settings.service';
import { LabelMode } from 'devextreme/common';
import { LabelLocation } from 'devextreme/ui/form';
import { CtGenLookupComponent } from '../ct-gen-lookup/ct-gen-lookup.component';
import { DysService } from 'libs/bys/src/lib/components/ortak/services/dys.service';
import { UtilsService } from '../../services/utils.service';
import { ScreenService } from '../../services/screen.service';
import { BysBelgeDagitim, BysBelgeNot } from 'libs/bys/src/lib/models/bys.models';
import { bilgiGeregi } from 'libs/bys/src/lib/shared/constants/birimTur';
import { CtlGenKisiComponent } from '../controls/ctl-gen-kisi/ctl-gen-kisi.component';
import { PdfViewUstVeriComponent } from './pdf-view-ust-veri/pdf-view-ust-veri.component';
import { alert, confirm } from 'devextreme/ui/dialog';
import { UstYaziPopupComponent } from 'libs/bys/src/lib/components/ortak/ust-yazi-popup/ust-yazi-popup.component';
import { PdfViewOtherUstVeriComponent } from './pdf-view-other-ust-veri/pdf-view-other-ust-veri.component';
import { DocViewerManagerComponent } from '../doc-viewer-manager/doc-viewer-manager.component';
import { CtGenRadioBtnComponent } from '../ct-gen-radio-btn/ct-gen-radio-btn.component';
import { PdfViewBelgeNotCrudPopupComponent } from './pdf-view-belge-not-crud-popup/pdf-view-belge-not-crud-popup.component';
// DKM-5139: "İlişkiler" sekmesi (belge ilişki silsilesi)
import { BelgeSilsileComponent } from 'libs/bys/src/lib/components/ortak/belge-silsile/belge-silsile.component';

@Pipe({ name: 'templateDataText', standalone: true })
export class TemplateDataTextPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'I': return 'İşlemde';
      case 'K': return 'Tamamlandı';
      case 'R': return 'Red Edildi';
      case 'P': return 'İptal Edildi';
      default: return '';
    }
  }
}

@Component({
  selector: 'dk-pdf-view',
  standalone: true,
  imports: [CommonModule,NgxExtendedPdfViewerModule,DxTabPanelModule,DkDxDataCtlTableComponent,DkFormPopupComponent,DxTabsModule,CtlGenKisiComponent,
    DxToolbarModule,DxButtonModule,DxScrollViewModule,DxLoadPanelModule,
  DxFormModule,CtGenLookupComponent,PdfViewUstVeriComponent,UstYaziPopupComponent,PdfViewOtherUstVeriComponent,DocViewerManagerComponent,
  // DKM-5139 Clara: eski hâli
  // TemplateDataTextPipe,CtGenRadioBtnComponent, CtGenRadioBtnComponent, PdfViewBelgeNotCrudPopupComponent],
  TemplateDataTextPipe,CtGenRadioBtnComponent, CtGenRadioBtnComponent, PdfViewBelgeNotCrudPopupComponent, BelgeSilsileComponent],
  templateUrl: './pdf-view.component.html',
  styleUrls: ['./pdf-view.component.scss'],
})
export class PdfViewComponent implements OnInit, OnChanges {
  @Input() belgeKod:number;
  @Input() evrakKod:number;
  @Input() gelenGiden:string;
  @Input() pageData :any
  @Input() isLayoutOpen:boolean
  @Input() isView = false;
  @Input() tarihEkleEh = "H"
  @Input() formMetaData: FormDto;
  @Input() dagitimEditPermission: boolean = false;
  @Input() selectedTabIndex = 0;
  @Input() otherUstVeri = false;
  @Output() layoutEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  isLoading=false;
  documentLoad= false;
  documentLoadUstYazi= false;
  public spreadMode: 'off' | 'even' | 'odd' = 'off';
public page = 1;
public pageLabel!: string;

gridCtl$: Observable<DlistDto>;
 public columnList: ColumnModel[];
public dataSource: any;

gridCtlIlgi$: Observable<DlistDto>;
 public columnListIlgi: ColumnModel[];
public dataSourceIlgi: any;

gridCtlDagitim$: Observable<DlistDto>;
 public columnListDagitim: ColumnModel[];
public dataSourceDagitim: any;

gridCtlSurec$: Observable<DlistDto>;
public columnListSurec: ColumnModel[];
public dataSourceSurec: any;

gridCtlSurecDetay$: Observable<DlistDto>;
 public columnListSurecDetay: ColumnModel[];
public dataSourceSurecDetay: any;

gridCtlEvrak$: Observable<DlistDto>;
 public columnListEvrak: ColumnModel[];
public dataSourceEvrak: any;

gridCtlHavale$: Observable<DlistDto>;
 public columnListHavale: ColumnModel[];
public dataSourceHavale: any;

gridCtlLog$: Observable<DlistDto>;
 public columnListLog: ColumnModel[];
public dataSourceLog: any;

gridCtlNot$: Observable<DlistDto>;
 public columnListNot: ColumnModel[];
public dataSourceNot: any;

private destroy$ = new Subject<void>();
selectedRow:any;//vBysGorev dto kullanilabilir
dListName = "BysBelgeEk"
dListNameIlgi = "BysBelgeIlgi"
dListNameDagitim = "BysBelgeDagitimC1Giden"
dListNameSurec = "vEbysSurecIzle"
dListNameSurecDetay = "vEbysSurecDetayIzle"
dListNameEvrak = "vEbysEvrakIzle"
dListNameHavale = "BysBelgeHavale"
dListNameLog = "BysBelgeLog"
dListNameNot = "BysBelgeNot";
  fileUrl: SafeResourceUrl;
  fileUrlUstYazi: SafeResourceUrl;

  belgeIlgiData:any;
  belgeEklerData:any;
  belgeSurecData:any;
  belgeEvrakData:any;
  belgeHavaleData:any;

  focusedRowIndexIlgi = -1;
  focusedRowIndexDagitim = -1;
  focusedRowIndexEkler = -1;
  focusedRowIndexSurec = -1;
  focusedRowIndexEvrak = -1;
  focusedRowIndexHavale = -1;
  public base64Src: string;
  isErrorIframe = false;
  isErrorIframeUstYazi = false;
  failedDocLoadMsg = 'Belge Seçiniz';
  failedDocLoadMsgUstYazi = 'Belge Bulunamadı';
  fileUrlEk: SafeResourceUrl;
  isFileImage: boolean;
  isFileImageUstYazi: boolean;
  /** DKM-5164 Cedric: html/txt belge → dk-doc-viewer-manager kum havuzlu iframe ile gösterir */
  htmlUstYazi = false;
  htmlEk = false;
  /** DKM-5164 Cedric: tarayıcının gösteremediği üst yazı (Saysis tif, eyp, doc...) → önizleme yerine "İndir" */
  indirilirUstYazi = false;
  ustYaziUzanti = '';
  private ustYaziBlobUrl: string;
  private ustYaziDosyaAd: string;
  public showBelge = false;
  public showBelgeIlgi = false;
    protected readonly bilgiGeregi = bilgiGeregi;
    selectedBelgeDagitim: BysBelgeDagitim = new BysBelgeDagitim();
    selectedBelgeDagitimCopy: BysBelgeDagitim;
  labelMode:LabelMode = this.globalSettings.globalLabelMode;
  labelLocation:LabelLocation = this.globalSettings.globalLabelLocation;

  editModeDagitim:boolean = false;

  bysBelgeNotPopupVisible:boolean = false;
  // DKM-5139: "İlişkiler" sekmesi ilk seçilene kadar yüklenmez (servis çağrısı sekme açılınca)
  iliskilerYuklendi = false;
  selectedBysBelgeNotRow:BysBelgeNot;

  belgeGorBtn=[{
    name:'BelgeGor',
    icon: 'eyeopen',
    stylingMode: 'outlined',
    type: 'default',
    disabled: false,
    clickHandler: () => { },
  },]
  docId:number;
constructor(private pdfViewerService: NgxExtendedPdfViewerService, public service: PdfViewService, private ortakService: OrtakService,
   private dysService: DysService, private utilService: UtilsService,
      public sanitizer: DomSanitizer,private globalSettings:DkGlobalUserSettingsService,
      protected screen: ScreenService){
    pdfDefaultOptions.assetsFolder = 'assets/bleeding-edge';
}

ngOnInit(): void {
  this.service.getUstYazi(this.belgeKod,this.tarihEkleEh).subscribe(res=>{
    if(res.result){
      this.docId=res.dysKod
      this.base64Src = res.dysContent;
      this.base64Change(res.dysName,res.dysType);
    }
    // LOG-ANALIZ 29.10: eski hâli — üst yazısı olmayan (eski aktarım/taslak) belgede de hata popup'ı açılıyordu
    // else{
    //   this.utilService.showError(res.errorMessage,"Üst Yazı Hata")
    // }
    else if (this.ustYaziYokMu(res.errorMessage)) {
      this.documentLoadUstYazi = false;
      this.failedDocLoadMsgUstYazi = 'Bu belgenin üst yazısı sistemde kayıtlı değil.';
    }
    else{
      this.utilService.showError(res.errorMessage,"Üst Yazı Hata")
    }
  })

  this.dataSource = this.service.dListDataSource(this.belgeKod);
  this.gridCtl$ = this.service.gridControlsList$;
  this.service.getDlist(this.dListName);
  this.service.gridControlsList$.pipe(takeUntil(this.destroy$)).subscribe(x => {
    this.columnList = this.ortakService.setRecursiveFieldData([x],false);
  })
  this.dataSourceIlgi = this.service.dListDataSourceIlgi(this.belgeKod);
  this.gridCtlIlgi$ = this.service.gridControlsListIlgi$;
  this.service.getDlist(this.dListNameIlgi);
  this.service.gridControlsListIlgi$.pipe(takeUntil(this.destroy$)).subscribe(x => {
    this.columnListIlgi = this.ortakService.setRecursiveFieldData([x]);
    this.columnListIlgi.map(x=>{
      if(x.type == 4){
        x.type = 15
      }
    })
  })
  this.dataSourceDagitim = this.service.dListDataSourceDagitim(this.belgeKod);
  this.gridCtlDagitim$ = this.service.gridControlsListDagitim$;
  this.service.getDlist(this.dListNameDagitim);
  this.service.gridControlsListDagitim$.pipe(takeUntil(this.destroy$)).subscribe(x => {
    this.columnListDagitim = this.ortakService.setRecursiveFieldData([x],false);
  })
  this.dataSourceSurec = this.service.dListDataSourceSurec(this.belgeKod);
  this.gridCtlSurec$ = this.service.gridControlsListSurec$;
  this.service.getDlist(this.dListNameSurec);
  this.service.gridControlsListSurec$.pipe(takeUntil(this.destroy$)).subscribe(x => {
    this.columnListSurec = this.ortakService.setRecursiveFieldData([x],false);
  })
  this.gridCtlSurecDetay$ = this.service.gridControlsListSurecDetay$;
  this.service.getDlist(this.dListNameSurecDetay);
  this.service.gridControlsListSurecDetay$.pipe(takeUntil(this.destroy$)).subscribe(x => {
    this.columnListSurecDetay = this.ortakService.setRecursiveFieldData([x],false);
  })
  this.dataSourceEvrak = this.service.dListDataSourceEvrak(this.belgeKod);
  this.gridCtlEvrak$ = this.service.gridControlsListEvrak$;
  this.service.getDlist(this.dListNameEvrak);
  this.service.gridControlsListEvrak$.pipe(takeUntil(this.destroy$)).subscribe(x => {
    this.columnListEvrak = this.ortakService.setRecursiveFieldData([x],false);
  })
  this.dataSourceHavale = this.service.dListDataSourceHavale(this.belgeKod,this.evrakKod);
  this.gridCtlHavale$ = this.service.gridControlsListHavale$;
  this.service.getDlist(this.dListNameHavale);
  this.service.gridControlsListHavale$.pipe(takeUntil(this.destroy$)).subscribe(x => {
    if(this.pageData.path === '/BYS/BysEvrakHavaleForm') this.columnListHavale = this.ortakService.setRecursiveFieldData([x]);
    else this.columnListHavale = this.ortakService.setRecursiveFieldData([x],false);
  })

  this.dataSourceLog = this.service.dListDataSourceLog(this.belgeKod);
  this.gridCtlLog$ = this.service.gridControlsListLog$;
  this.service.getDlist(this.dListNameLog);
  this.service.gridControlsListLog$.pipe(takeUntil(this.destroy$)).subscribe(x => {
    this.columnListLog = this.ortakService.setRecursiveFieldData([x],false);
  })

  this.dataSourceNot = this.service.dListDataSourceNot(this.belgeKod);
  this.gridCtlNot$ = this.service.gridControlsListNot$;
  this.service.getDlist(this.dListNameNot);
  this.service.gridControlsListNot$.pipe(takeUntil(this.destroy$)).subscribe(x => {
    this.columnListNot = this.ortakService.setRecursiveFieldData([x]);
  })



}

ngOnDestroy(){
  this.destroy$.next();
  this.destroy$.complete();
}

ngOnChanges(changes: SimpleChanges): void {
    if(changes['belgeKod']){
      //this.selectedTabIndex = 0;
    }
}

public onPageRendered(): void {
  if (!this.pdfViewerService.isRenderQueueEmpty()) {
    // try again later when the pages requested by the pdf.js core or the user have been rendered
    setTimeout(() => this.onPageRendered(), 100);
  }

  const pagesBefore = this.spreadMode === 'off' ? 2 : 2;
  const pagesAfter = this.spreadMode === 'off' ? 2 : 5;
  const startPage = Math.max(this.page - pagesBefore, 1);
  const endPage = Math.min(this.page  + pagesAfter, this.pdfViewerService.numberOfPages());

  const renderedPages = this.pdfViewerService.currentlyRenderedPages();

  for (let page = startPage; page <= endPage; page++) {
    const pageIndex = page - 1;
    if (!this.pdfViewerService.hasPageBeenRendered(pageIndex)) {
        this.pdfViewerService.addPageToRenderQueue(pageIndex);
        break; // break because you can request only one page at a time
    }
  }
}

// DKM-5139: sekme başlığına göre (indeks gizli sekmelerle kayar) İlişkiler'i ilk seçimde yükle
onTabSelectionChanged(e: any) {
  if (e?.addedItems?.some((x: any) => x?.title === 'İlişkiler')) {
    this.iliskilerYuklendi = true;
  }
}

closeLayout() {
  this.isLayoutOpen = false;
  this.layoutEmitter.emit(this.isLayoutOpen);
}




focusedRowChangedIlgi(e:FocusedRowChangedEvent){
  if(e?.row?.data?.Kod){
    this.belgeIlgiData = e.row.data;
    this.focusedRowIndexIlgi = e.row.rowIndex;
  }

}

focusedRowChangedHavale(e:FocusedRowChangedEvent){
  if(e?.row?.data?.Kod){
    this.belgeHavaleData = e.row.data;
    this.focusedRowIndexHavale = e.row.rowIndex;
  }

}


focusedRowChangedDagitim(e:FocusedRowChangedEvent){
  if(e?.row?.data?.Kod){
    this.selectedBelgeDagitim = e.row.data;
    this.focusedRowIndexDagitim = e.row.rowIndex;
  }

}

focusedRowChangedEkler(e:FocusedRowChangedEvent){
  if(e?.row?.data?.Kod){
    this.belgeEklerData = e.row.data;
    this.focusedRowIndexEkler = e.row.rowIndex;
    if (this.belgeEklerData.BelgeDysKod) {
      this.getDocument(this.belgeEklerData.BelgeDysKod);
    }
    // LOG-ANALIZ 29.10: dosyası olmayan ek seçilince önceki ekin önizlemesi ekranda kalıyordu
    else {
      this.ekDosyasiYok();
    }
  }
}

// LOG-ANALIZ 29.10: dosyası yüklenmemiş ek için sakin bilgi (servise dysId 0 ile istek atılmaz)
ekDosyasiYok() {
  this.documentLoad = false;
  this.fileUrlEk = undefined;
  this.failedDocLoadMsg = 'Bu eke henüz dosya yüklenmemiş.';
}

// LOG-ANALIZ 29.10: servisin "üst yazı yok" yanıtları hata değil, bilgi olarak gösterilir
ustYaziYokMu(mesaj: string): boolean {
  const m = (mesaj ?? '').toString();
  return m.startsWith('Üst Yazı Kaydı yok') || m.includes('henüz üst yazısı yok');
}

focusedRowChangedSurec(e:FocusedRowChangedEvent){
  if(e?.row?.data?.Kod){
    this.belgeSurecData = e.row.data;
    this.focusedRowIndexSurec = e.row.rowIndex;
    this.dataSourceSurecDetay = this.service.dListDataSourceSurecDetay(this.belgeSurecData.Kod);
  }

}
focusedRowChangedEvrak(e:FocusedRowChangedEvent){
  if(e?.row?.data?.Kod){
    this.belgeEvrakData = e.row.data;
    this.focusedRowIndexEvrak = e.row.rowIndex;
  }

}

handleDagitimEditClick(){
  this.editModeDagitim = true;
  this.selectedBelgeDagitimCopy = structuredClone(this.selectedBelgeDagitim);

}

handleDagitimSaveClick(){
  if(this.formMetaData?.formYetki?.updateYn){

    this.service.upgradeBysBelgeDagitim(this.selectedBelgeDagitim).then(
      (res) => {
        this.editModeDagitim = false;
        this.utilService.showSuccess('Dagitim Güncellendi');
        this.selectedBelgeDagitim = res;
        this.selectedBelgeDagitimCopy = structuredClone(this.selectedBelgeDagitim);
      },(err) => {
        this.utilService.showError(err);
      });
    }else {
      this.utilService.showError('Yetkiniz Yok');
    }
}

onDagitimCloseClick(){

this.editModeDagitim = false;
}

showDelete(e: any) {
  if(e.row.data.SonucTarih){
    alert('Sonuç tarihi boş olmalıdır!', 'Uyarı!');
  }
  else{
    if (this.formMetaData.formYetki.deleteYn) {
      confirm('Bu satırı silmek istiyor musunuz?', 'Silme Onayı').then(
        (res) => {
          if (res) {
            this.service.removeHavale(e.row.data).then(
              () => {
                this.utilService.showSuccess('İşlem Başarılı');
                this.service.errorResponse = null;
                this.dataSourceHavale.reload();
              },
              (err) => {
                this.utilService.showError(err.message);
                this.service.errorResponse = err;
              }
            );
          }
        }
      );
    } else {
      this.utilService.showError('Yetkiniz yok!');
    }
  }
}


clickOtherBtn(e:any){
  if(e?.button?.button?.name == 'BelgeGor'){
    this.showBelgeIlgi = true;
  }

}


  onRowPrepared(e:RowPreparedEvent){
    if (e?.rowType == 'data' && e?.data?.ReferansKod == null) {
      const buttonColumn = e.columns.find((x: any) => x?.type == 'buttons');
      if (buttonColumn) {
          buttonColumn.buttons = buttonColumn.buttons.filter((y: any) => y?.text != 'BelgeGor');
      }
  }
  }

base64Change(dysName: string,dysType: string){
  if(this.base64Src){

    // DKM-5164 Cedric: eski hâli — pdf dışındaki her şey <img> ile gösteriliyordu (Saysis'ten aktarılan .html/.txt üst yazılar boş kalıyordu)
    //this.isFileImageUstYazi = dysType==='pdf'?false:dysName.endsWith("pdf")?false:true;
    this.isFileImageUstYazi = !this.iframeIleGosterilir(dysName, dysType);
    this.htmlUstYazi = this.htmlMi(dysName, dysType); // DKM-5164 Cedric
    let content = this.base64Src.split('base64,').pop();
    const byteCharacters = atob(content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const mimeType = this.service.getMimeTypeFromName(dysName);
  const base64Type=this.service.getExtensionFromType(mimeType);
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: base64Type});
  const url = URL.createObjectURL(blob);
  this.fileUrlUstYazi = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  // DKM-5164 Cedric: tif/eyp/doc... tarayıcıda gösterilemez → kırık resim yerine "İndir" (içerik zaten yüklü, servis çağrısı yok)
  this.ustYaziBlobUrl = url;
  this.ustYaziDosyaAd = (dysName || '').split(/[\\/]/).pop() || ('belge.' + (dysType || 'bin'));
  this.ustYaziUzanti = this.uzantiAl(dysName, dysType);
  this.indirilirUstYazi = PdfViewComponent.INDIRILIR_TURLER.includes(this.ustYaziUzanti);
  this.documentLoadUstYazi = true;
  }
}
/** DKM-5164 Cedric: tarayıcının görüntüleyemediği türler — önizleme yerine indirilir. Liste bilerek kapalı
 *  (yalnız bilinen türler): uzantısı olmayan / bilinmeyen belgeler eskisi gibi gösterilmeye çalışılır. */
static readonly INDIRILIR_TURLER = ['tif', 'tiff', 'eyp', 'doc', 'docx', 'odt', 'rtf', 'xls', 'xlsx', 'ods', 'ppt', 'pptx',
  'rar', 'zip', '7z', 'p7s', 'imz', 'xml', 'udf', 'dwg', 'dxf', 'kml', 'kmz', 'ncz', 'ncy', 'ncn', 'eml', 'msg', 'csv', 'url', 'mp4'];
private uzantiAl(dysName: string, dysType: string): string {
  const ad = (dysName || '').toLowerCase();
  const nokta = ad.lastIndexOf('.');
  return nokta >= 0 && nokta > ad.lastIndexOf('/') ? ad.substring(nokta + 1) : (dysType || '').toLowerCase().replace(/^\./, '');
}
/** DKM-5164 Cedric: gösterilemeyen üst yazıyı dosya adıyla indirir. */
ustYaziIndir() {
  if (!this.ustYaziBlobUrl) return;
  const a = document.createElement('a');
  a.href = this.ustYaziBlobUrl;
  a.download = this.ustYaziDosyaAd;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
/** DKM-5164 Cedric: iframe'de açılacak belgeler (pdf + Saysis'ten aktarılan html/txt yazılar); diğerleri eskisi gibi <img>. */
private iframeIleGosterilir(dysName: string, dysType: string): boolean {
  const ad = (dysName || '').toLowerCase();
  const tur = (dysType || '').toLowerCase();
  return tur === 'pdf' || ad.endsWith('pdf') || ['html', 'htm', 'txt'].includes(tur)
    || ad.endsWith('.html') || ad.endsWith('.htm') || ad.endsWith('.txt');
}
/** DKM-5164 Cedric: kum havuzlu iframe'de açılacak metin belgeleri (html/htm/txt). */
private htmlMi(dysName: string, dysType: string): boolean {
  const ad = (dysName || '').toLowerCase();
  const tur = (dysType || '').toLowerCase();
  return ['html', 'htm', 'txt'].includes(tur) || ad.endsWith('.html') || ad.endsWith('.htm') || ad.endsWith('.txt');
}
onDocumentLoad() {
  this.documentLoad = true;
}

onFileError() {
  this.documentLoad = false;
  this.isErrorIframe = true;
}
onDocumentLoadUstYazi() {
  this.documentLoad = true;
}

onFileErrorUstYazi() {
  this.documentLoadUstYazi = false;
  this.isErrorIframeUstYazi = true;
}

belgeGoster(){
  this.showBelge = true;
}

belgeIndir(){
  if (this.belgeEklerData.BelgeDysKod) {
    this.downloadDoc(this.belgeEklerData.BelgeDysKod,this.belgeEklerData?.BelgeAd,this.belgeEklerData.Kod);
  } else this.utilService.showError('Seçili belgenin içeriği mevcut değildir.');
}

downloadDoc(dysId: string,fileName:string,belgeEkKod:number) {
  if(dysId?.startsWith('F@')){
    this.dysService.downloadSablonDoc(dysId,fileName,true,belgeEkKod);
  }
  else this.dysService.downloadSablonDoc(dysId,fileName);
  // this.dysService.downloadSablonDoc(dysId).subscribe({
  //   next:(res)=>{
  //     if(res){
  //       this.utilService.showSuccess('Belge İndirildi');
  //     }
  //     else{
  //       this.utilService.showWarning('Belge İndirme Başarısız');
  //     }
  //   },
  //   error:(err)=>{
  //     this.utilService.showError(err.errorMessage)
  //   }
  // });
}

getDocument(dysKod: any) {
  // LOG-ANALIZ 29.10: boş/0 DYS kodu ile "Dys No boş olamaz" isteği atılmaz ("F@..." disk belgesi geçerlidir)
  const kod = (dysKod ?? '').toString().trim();
  if (kod === '' || kod === '0') {
    this.ekDosyasiYok();
    return;
  }
  this.dysService.getDocument("BelgeEk",this.belgeEklerData.BelgeKod,this.belgeEklerData.Kod,Number(dysKod)).subscribe({
    next: (res) => {
      if (res.result) {
        this.failedDocLoadMsg = '';
        // DKM-5164 Cedric: eski hâli — pdf dışındaki her şey <img> ile gösteriliyordu (.html/.txt ekler boş kalıyordu)
        //this.isFileImage = res.dysType === 'pdf' ? false :res.dysName.endsWith("pdf")?false:true;
        this.isFileImage = !this.iframeIleGosterilir(res.dysName, res.dysType);
        this.htmlEk = this.htmlMi(res.dysName, res.dysType); // DKM-5164 Cedric
        const mimeType = this.service.getMimeTypeFromName(res.dysName);
        const base64Type=this.service.getExtensionFromType(mimeType);
        let base64 =  res.dysContent.startsWith('data:') ? res.dysContent.split(',')[1] : res.dysContent;
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: base64Type});
        const url = URL.createObjectURL(blob);
        this.fileUrlEk = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.documentLoad = true;
      } else {
        this.utilService.showError(res.errorMessage);
        this.documentLoad = false;
        this.fileUrlEk = undefined;
        this.failedDocLoadMsg = 'Belge Bulunamadı';
      }
    },
    error: (err) => {
      // this.utilService.showError(JSON.stringify(err));
      // this.documentLoad = false;
      // this.fileUrlEk = undefined;
      // this.failedDocLoadMsg = 'Belge Bulunamadı';
    },
  });
}


  showAddBysNot(){

    this.ortakService
      .getNewFormData('BysBelgeNot')
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.selectedBysBelgeNotRow = res;
        this.selectedBysBelgeNotRow.BelgeKod = this.belgeKod;
        this.bysBelgeNotPopupVisible = true;
      });

  }

  showDeleteBysNot(e:any){
     if (this.formMetaData.formYetki.deleteYn) {
      confirm('Silmek istediğinize emin misiniz?', 'Silme İşlemi').then(res => {
        if (res) {
          this.service.deleteBysBelgeNot(e.row.data).then(
            () => {
              this.utilService.showSuccess('İşlem Başarılı');
              this.dataSourceNot.reload();
            },
            (err) => {
              this.utilService.showError(err);
            })
        }
      })
    } else {
      this.utilService.showError('Bu işlem için yetkiniz yok!')
    }
  }


  closeAfterPopupBelgeNot(e:any){
    this.bysBelgeNotPopupVisible = false;
    if(e == 'insert'){
      this.dataSourceNot.reload();
    }
  }
}
